var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:['firstTitle',{ secondTitle: _vm.isActiveSec },{'width-700':_vm.isWidth700},{'width-840':_vm.isWidth840}]},[_c('i'),_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }